import { getBposNavBarData } from 'owa-bpos-store';
import { getUserConfiguration } from 'owa-session-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { trace } from 'owa-trace';

const AAD_LICENSE_TAG: string = 'OfficeProPlus';

export enum LicenseType {
    NoLicense = 'NoLicense',
    Perpetual = 'Perpetual',
    Subscription = 'Subscription',
}

export default function getUserLicenseType(): LicenseType {
    if (isConsumer()) {
        const userConfig = getUserConfiguration();
        return userConfig.SessionSettings.IsPremiumConsumerMailbox
            ? LicenseType.Subscription
            : LicenseType.NoLicense;
    } else {
        const bposData = getBposNavBarData();
        try {
            const clientData = JSON.parse(bposData.ClientData);
            return parseActiveExperiences(clientData?.ActiveExperiences);
        } catch (error) {
            trace.warn('Error parsing bposClientData ActiveExperiences: ' + error?.message);
            return LicenseType.NoLicense;
        }
    }
}

function parseActiveExperiences(activeExperiences: string): LicenseType {
    return activeExperiences &&
        activeExperiences.split(',').some(value => value === AAD_LICENSE_TAG)
        ? LicenseType.Subscription
        : LicenseType.NoLicense;
}
